import React from 'react';

const Links = () => {
    const resources = [
        { name: 'Blog', url: 'https://medium.com/@r4j3sh' },
        { name: 'GitBook', url: 'https://gitbook.r4j3sh.com' },
        { name: 'GitHub', url: 'https://github.com/r4j3sh-com' },
        { name: 'LinkedIn', url: 'https://linkedin.com/in/r4j3sh' }
    ];

    return (
        <section id="links" className="p-10">
            <h3 className="text-2xl font-semibold text-center mb-6">Find Me Online</h3>
            <div className="flex justify-center gap-6 flex-wrap">
                {resources.map(link => (
                    <a key={link.name} href={link.url} target="_blank" rel="noopener noreferrer"
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
                        {link.name}
                    </a>
                ))}
            </div>
        </section>
    );
};

export default Links;